import { render, staticRenderFns } from "./cover-drawer.vue?vue&type=template&id=2a8fdb2f"
import script from "./cover-drawer.vue?vue&type=script&lang=js"
export * from "./cover-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports